import { Check, XCircle } from "lucide-react";
import { toast } from "sonner";

export function showNotInterestedToast() {
  toast("Job hidden", {
    description:
      "Thanks — we'll use this to find you better matches. You can see hidden jobs with the “Jobs I passed on” filter.",
    duration: 3000,
    icon: <Check className="h-5 w-5 text-green-500" />,
  });
}

export function showNotInterestedErrorToast() {
  toast.error("Couldn't save your response", {
    description: "Please try again.",
    duration: 4000,
    icon: <XCircle className="h-5 w-5 text-red-500" />,
  });
}
